export const VideoCallModal = () => {
  return (
    <div className="modal-container">
      <div className="modal">
        <video muted></video>
        <video muted></video>
      </div>
    </div>
  );
};
